import { Box, Card, CardContent, Typography } from '@mui/material'
import { tokens } from '@/Layout/theme'
import { useAdminRole } from '@/context/AdminRoleContext'
import { useAuth } from '@/context/AuthContext'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'

const colors = tokens()

export const Dashboard = () => {
  const { user } = useAuth()

  const { username } = user || {}

  // Same role, and the same request, that decides who gets the internal only pages.
  const { role: userRole } = useAdminRole()

  return (
    <Card>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center" pl={2}>
          <Typography variant="h2" sx={{ fontWeight: 800, color: colors.primary[800] }}>
            Welcome to Digital Zone Dashboard
          </Typography>
          <Box
            display="inline-flex"
            alignItems="center"
            borderRadius={2}
            gap={2}
            p={2}
            pr={4}
            bgcolor={colors.cyanosed[100]}
          >
            <AccountCircleOutlinedIcon
              sx={{
                fontSize: '82px',
                color: colors.primary[800],
              }}
            />

            <Box display="flex" flexDirection="column">
              <Typography fontSize={16} fontWeight="600">
                {username}
              </Typography>
              {userRole && (
                <Typography variant="body2" fontSize={14}>
                  Role: {userRole}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}
